import { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const WhatsAppButton = () => {
  const [whatsappPhone, setWhatsappPhone] = useState('34678744482');
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Cargar el teléfono de la configuración
    axios.get(`${API}/settings`)
      .then(res => {
        if (res.data?.whatsapp_phone) {
          setWhatsappPhone(res.data.whatsapp_phone.replace(/\s/g, ''));
        }
      })
      .catch(err => console.error('Error fetching settings for WhatsApp:', err));
    
    // Mostrar el tooltip después de unos segundos
    const timer = setTimeout(() => setShowTooltip(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppRedirect = () => {
    const message = encodeURIComponent("¡Hola! Me gustaría recibir información sobre vuestros viajes de ensueño.");
    const url = `https://wa.me/${whatsappPhone}?text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-3">
      {/* Tooltip opcional */}
      {showTooltip && (
        <div className="bg-white px-4 py-2 rounded-xl shadow-xl border border-slate-100 flex items-center gap-2 animate-in fade-in slide-in-from-right-4">
          <span className="text-sm font-medium text-slate-700">¿Hablamos por WhatsApp?</span>
          <button onClick={() => setShowTooltip(false)}><X className="w-3 h-3 text-slate-400" /></button>
        </div>
      )}

      {/* Botón Principal */}
      <button
        onClick={handleWhatsAppRedirect}
        className="group relative flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300"
        aria-label="Chat en WhatsApp"
      >
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <MessageCircle className="w-8 h-8 relative z-10 fill-white" />
        
        {/* Badge estético */}
        <span className="absolute -top-1 -right-1 flex h-4 w-4">
          <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 border-2 border-white"></span>
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;
